import Devices from "../Devices/Devices"

const CompliantDevices = () => (
  <Devices
    preset={{ compliance: "Compliant" }}
    locked={["compliance"]}
    title="Compliant devices"
  />
)

export default CompliantDevices
